import { createContext, useContext } from "react";
import type { CompanySummary } from "./queries";

export const CompanyContext = createContext<CompanySummary | null>(null);

/** The company currently being viewed. Available anywhere under /c/:companyId. */
export function useCompany(): CompanySummary {
    const company = useContext(CompanyContext);
    if (!company) throw new Error("useCompany must be used inside a company route");
    return company;
}
